import { FormGroup } from '@angular/forms';

export enum OfficeFormGroupsEnum {
  keyFields = 'keyFields',
  editFields = 'editFields',
}

export interface OfficeToolsFormGroup {
  [OfficeFormGroupsEnum.keyFields]: FormGroup;
  [OfficeFormGroupsEnum.editFields]: FormGroup;
}
